import { createContext, ReactNode } from 'react';

type FlowBuilderMode = 'edit' | 'localize';

interface FlowBuilderContextValue {
  mode: FlowBuilderMode;
  flowId?: string;
  languageCode?: string;
  isReadOnly: boolean;
  canEditLabels: boolean;
  canEditStructure: boolean;
}

export const FlowBuilderContext = createContext<FlowBuilderContextValue | undefined>(
  undefined
);

interface FlowBuilderProviderProps {
  mode: FlowBuilderMode;
  flowId?: string;
  languageCode?: string;
  children: ReactNode;
}

export function FlowBuilderProvider({
  mode,
  flowId,
  languageCode,
  children,
}: FlowBuilderProviderProps) {
  const value: FlowBuilderContextValue = {
    mode,
    flowId,
    languageCode,
    isReadOnly: mode !== 'edit',
    canEditLabels: mode === 'localize' || mode === 'edit',
    canEditStructure: mode === 'edit',
  };

  return (
    <FlowBuilderContext.Provider value={value}>
      {children}
    </FlowBuilderContext.Provider>
  );
}
